import React, { useEffect, useState } from "react";
import styles from "../ConsultationHistory/Index.module.scss";
import { Drawer } from "antd";
//import ConsultationHistoryModalContent from "./ConsultationHistoryModalContent";

const AppointmentDetails = () => {
  const consultationHistory_dummy = [
    {
      appointmentId: 1,
      doctorName: "Dr. Smith",
      reasonForVisit: "Cough and Cold",
      appointmentDate: "2023-08-10",
      action: "Prescribed medication",
    },
    {
      appointmentId: 2,
      doctorName: "Dr. Johnson",
      reasonForVisit: "Back Pain",
      appointmentDate: "2023-08-12",
      action: "Suggested physical therapy",
    },
    {
      appointmentId: 3,
      doctorName: "Dr. Williams",
      reasonForVisit: "Fever",
      appointmentDate: "2023-08-15",
      action: "Advised rest and fluids",
    },
    {
      appointmentId: 4,
      doctorName: "Dr. Brown",
      reasonForVisit: "Headache",
      appointmentDate: "2023-08-18",
      action: "Recommended relaxation techniques",
    },
    {
      appointmentId: 5,
      doctorName: "Dr. Miller",
      reasonForVisit: "Annual Checkup",
      appointmentDate: "2023-08-20",
      action: "Reviewed overall health",
    },
  ];
 
  const [consultationHistory, setConsultationHistory] = useState();
  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setConsultationHistory(consultationHistory_dummy);
  }, []);

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const moreButtonOnClick = (id)=>{
    setModalOpen(true)
  }

  return (
    <div className={styles.container}>
      <div className="appoinment-table-wrap">
        <table className={styles.consultationHistoryTable}>
         

          <tbody>
            <tr>
                <td>Appointment Date</td>
                <td>10-Aug-2023</td>
            </tr>
          </tbody>
        </table>
      </div>

     
    </div>
  );
};

export default AppointmentDetails;
